import React, { useState, Fragment } from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent } from '../components/Card';
import { FileSearch, ChevronRight, Hash, Clock, User, FileText } from 'lucide-react';
import { Badge } from '../components/Badge';
import { Button } from '../components/Button';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../components/Dialog';
import { Gavel, ExternalLink, Briefcase } from 'lucide-react';
import { RelatedWorkflow } from '../components/dashboard/RelatedWorkflow';
const stages = ['Pelaporan', 'Verifikasi', 'Investigasi', 'Berkas Hukum', 'Selesai'];
const items = [{
  id: 'CASE-2026-014',
  title: 'Deepfake audio Presiden - operasi TikTok',
  stage: 2,
  assignee: 'Bareskrim Siber Polri',
  priority: 'KRITIS',
  opened: '12 jam lalu'
}, {
  id: 'CASE-2026-013',
  title: 'Akun impersonation @presidenri_official',
  stage: 3,
  assignee: 'Tim Hukum KSP & Komdigi',
  priority: 'TINGGI',
  opened: '1 hari lalu'
}, {
  id: 'CASE-2026-012',
  title: 'Hoaks penarikan dana haji',
  stage: 1,
  assignee: 'Komdigi - Verifikasi Hoaks',
  priority: 'TINGGI',
  opened: '6 jam lalu'
}, {
  id: 'CASE-2026-011',
  title: 'Doxxing aparat keamanan Papua',
  stage: 2,
  assignee: 'Polda Papua & Densus',
  priority: 'KRITIS',
  opened: '2 hari lalu'
}, {
  id: 'CASE-2026-010',
  title: 'Buzzer cluster #TolakKebijakanX',
  stage: 4,
  assignee: 'Bareskrim Siber - selesai',
  priority: 'SEDANG',
  opened: '4 hari lalu'
}, {
  id: 'CASE-2026-009',
  title: 'Spam komentar IKN di YouTube',
  stage: 4,
  assignee: 'Komdigi & Tim Platform',
  priority: 'SEDANG',
  opened: '5 hari lalu'
}];
const prioColor: Record<string, string> = {
  KRITIS: 'bg-red-500/10 text-red-500',
  TINGGI: 'bg-amber-500/10 text-amber-500',
  SEDANG: 'bg-blue-500/10 text-blue-500'
};
export function CaseManagement() {
  const [selectedCase, setSelectedCase] = useState<(typeof items)[0] | null>(null);
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-1309">
      <PageHeader group="Hukum & Evidence" title="Case Management" description="Pipeline kasus hukum digital dari pelaporan hingga penyerahan berkas, dengan SLA dan PIC tertelusur." icon={FileSearch} data-id="element-1310" />

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-1311">
        {stages.map(s => <Card key={s} className="bg-card border-border/50" data-id="element-1312">
            <CardContent className="p-4 text-center" data-id="element-1313">
              <p className="font-mono text-[9px] uppercase text-muted-foreground mb-1" data-id="element-1314">
                Tahap {stages.indexOf(s) + 1}
              </p>
              <p className="font-heading text-sm font-bold" data-id="element-1315">{s}</p>
              <p className="font-mono text-xl font-bold text-amber-500 mt-1" data-id="element-1316">
                {items.filter(c => c.stage === stages.indexOf(s)).length}
              </p>
            </CardContent>
          </Card>)}
      </div>

      <div className="space-y-3" data-id="element-1317">
        {items.map(c => <Card key={c.id} className="bg-card border-border/50" data-id="element-1318">
            <CardContent className="p-4" data-id="element-1319">
              <div className="flex items-start justify-between gap-4 mb-3" data-id="element-1320">
                <div data-id="element-1321">
                  <div className="flex items-center gap-2 mb-1" data-id="element-1322">
                    <span className="font-mono text-xs text-muted-foreground" data-id="element-1323">
                      {c.id}
                    </span>
                    <Badge variant="outline" className={`font-mono text-[8px] px-1 py-0 h-4 border-none ${prioColor[c.priority]}`} data-id="element-1324">
                      {c.priority}
                    </Badge>
                  </div>
                  <h3 className="text-sm font-bold" data-id="element-1325">{c.title}</h3>
                  <p className="font-mono text-[10px] text-muted-foreground mt-1" data-id="element-1326">
                    PIC: {c.assignee} • Dibuka: {c.opened}
                  </p>
                </div>
                <Button size="sm" variant="outline" onClick={() => setSelectedCase(c)} data-id="element-1327">
                  Buka Berkas
                </Button>
              </div>

              <div className="flex items-center gap-1" data-id="element-1328">
                {stages.map((s, idx) => <Fragment key={s} data-id="element-1329">
                    <div className={`flex-1 flex flex-col items-center ${idx <= c.stage ? '' : 'opacity-30'}`} data-id="element-1330">
                      <div className={`w-full h-1 rounded-full ${idx <= c.stage ? idx === c.stage ? 'bg-amber-500' : 'bg-emerald-500' : 'bg-muted'}`} data-id="element-1331" />
                      <span className={`font-mono text-[9px] mt-1 ${idx === c.stage ? 'text-amber-500' : idx < c.stage ? 'text-emerald-500' : 'text-muted-foreground'}`} data-id="element-1332">
                        {s}
                      </span>
                    </div>
                    {idx < stages.length - 1 && <ChevronRight className="size-3 text-muted-foreground shrink-0" data-id="element-1333" />}
                  </Fragment>)}
              </div>
            </CardContent>
          </Card>)}
      </div>

      <Dialog open={!!selectedCase} onOpenChange={open => !open && setSelectedCase(null)} data-id="element-1334">
        <DialogContent className="sm:max-w-[500px] border-border/50 bg-background/95 backdrop-blur" data-id="element-1335">
          <DialogHeader data-id="element-1336">
            <div className="flex items-center gap-2 mb-1" data-id="element-1337">
              <span className="font-mono text-xs text-muted-foreground" data-id="element-1338">
                {selectedCase?.id}
              </span>
              {selectedCase && <Badge variant="outline" className={`font-mono text-[8px] px-1 py-0 h-4 border-none ${prioColor[selectedCase.priority]}`} data-id="element-1339">
                  {selectedCase.priority}
                </Badge>}
            </div>
            <DialogTitle className="text-base font-bold text-foreground" data-id="element-1340">
              {selectedCase?.title}
            </DialogTitle>
          </DialogHeader>

          {selectedCase && <div className="grid gap-5 py-2" data-id="element-1341">
              {/* Detail Kasus */}
              <div data-id="element-1342">
                <h4 className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground mb-2" data-id="element-1343">
                  Detail Kasus
                </h4>
                <div className="grid grid-cols-2 gap-2 text-xs" data-id="element-1344">
                  <div className="flex items-center gap-2" data-id="element-1345">
                    <User className="size-3.5 text-muted-foreground" data-id="element-1346" />
                    <span className="text-muted-foreground" data-id="element-1347">PIC:</span>
                    <span className="font-medium" data-id="element-1348">{selectedCase.assignee}</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1349">
                    <Clock className="size-3.5 text-muted-foreground" data-id="element-1350" />
                    <span className="text-muted-foreground" data-id="element-1351">Dibuka:</span>
                    <span className="font-medium" data-id="element-1352">{selectedCase.opened}</span>
                  </div>
                </div>

                {/* Mini Stepper */}
                <div className="flex items-center gap-1 mt-4" data-id="element-1353">
                  {stages.map((s, idx) => <Fragment key={s} data-id="element-1354">
                      <div className={`flex-1 flex flex-col items-center ${idx <= selectedCase.stage ? '' : 'opacity-30'}`} data-id="element-1355">
                        <div className={`w-full h-1 rounded-full ${idx <= selectedCase.stage ? idx === selectedCase.stage ? 'bg-amber-500' : 'bg-emerald-500' : 'bg-muted'}`} data-id="element-1356" />
                        <span className={`font-mono text-[8px] mt-1 ${idx === selectedCase.stage ? 'text-amber-500' : idx < selectedCase.stage ? 'text-emerald-500' : 'text-muted-foreground'}`} data-id="element-1357">
                          {s}
                        </span>
                      </div>
                      {idx < stages.length - 1 && <ChevronRight className="size-3 text-muted-foreground shrink-0" data-id="element-1358" />}
                    </Fragment>)}
                </div>
              </div>

              {/* Linimasa Kasus */}
              <div data-id="element-1359">
                <h4 className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground mb-2" data-id="element-1360">
                  Linimasa Kasus
                </h4>
                <div className="relative border-l border-border/50 ml-1.5 space-y-3" data-id="element-1361">
                  <div className="relative pl-4" data-id="element-1362">
                    <div className="absolute -left-1 top-1.5 size-2 rounded-full bg-emerald-500" data-id="element-1363" />
                    <p className="text-xs font-medium" data-id="element-1364">Laporan diterima</p>
                    <p className="font-mono text-[9px] text-muted-foreground" data-id="element-1365">
                      Hari ini, 08:00 WIB
                    </p>
                  </div>
                  <div className="relative pl-4" data-id="element-1366">
                    <div className="absolute -left-1 top-1.5 size-2 rounded-full bg-emerald-500" data-id="element-1367" />
                    <p className="text-xs font-medium" data-id="element-1368">
                      Verifikasi awal selesai
                    </p>
                    <p className="font-mono text-[9px] text-muted-foreground" data-id="element-1369">
                      Hari ini, 10:30 WIB
                    </p>
                  </div>
                  <div className="relative pl-4" data-id="element-1370">
                    <div className="absolute -left-1 top-1.5 size-2 rounded-full bg-amber-500 ring-2 ring-amber-500/20" data-id="element-1371" />
                    <p className="text-xs font-medium text-amber-500" data-id="element-1372">
                      Investigasi dilanjutkan ke Bareskrim
                    </p>
                    <p className="font-mono text-[9px] text-muted-foreground" data-id="element-1373">
                      Hari ini, 14:15 WIB
                    </p>
                  </div>
                </div>
              </div>

              {/* Bukti Terlampir */}
              <div data-id="element-1374">
                <h4 className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground mb-2" data-id="element-1375">
                  Bukti Terlampir
                </h4>
                <div className="space-y-2" data-id="element-1376">
                  <div className="flex items-center justify-between p-2 rounded border border-border/50 bg-muted/10" data-id="element-1377">
                    <div className="flex items-center gap-2" data-id="element-1378">
                      <FileText className="size-4 text-muted-foreground" data-id="element-1379" />
                      <div data-id="element-1380">
                        <p className="text-xs font-medium" data-id="element-1381">
                          video_deepfake_01.mp4
                        </p>
                        <p className="font-mono text-[9px] text-muted-foreground" data-id="element-1382">
                          SHA256: 8f4e...2b1a
                        </p>
                      </div>
                    </div>
                    <span className="font-mono text-[9px] text-muted-foreground" data-id="element-1383">
                      12.4 MB
                    </span>
                  </div>
                  <div className="flex items-center justify-between p-2 rounded border border-border/50 bg-muted/10" data-id="element-1384">
                    <div className="flex items-center gap-2" data-id="element-1385">
                      <FileText className="size-4 text-muted-foreground" data-id="element-1386" />
                      <div data-id="element-1387">
                        <p className="text-xs font-medium" data-id="element-1388">
                          log_aktivitas_bot.csv
                        </p>
                        <p className="font-mono text-[9px] text-muted-foreground" data-id="element-1389">
                          SHA256: 3a1c...9f2d
                        </p>
                      </div>
                    </div>
                    <span className="font-mono text-[9px] text-muted-foreground" data-id="element-1390">
                      2.1 MB
                    </span>
                  </div>
                </div>
              </div>
            </div>}

          <DialogFooter data-id="element-1391">
            <Button variant="outline" size="sm" onClick={() => setSelectedCase(null)} data-id="element-1392">
              Tutup
            </Button>
            <Button variant="default" size="sm" onClick={() => {
            toast.success('Kasus dieskalasi', {
              description: `Kasus ${selectedCase?.id} dilanjutkan ke tahap berikutnya.`
            });
            setSelectedCase(null);
          }} data-id="element-1393">
              Eskalasi Tahap Berikutnya
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <RelatedWorkflow currentStep="Manajemen Kasus" nextSteps={[{
      to: '/legal-evidence',
      icon: Gavel,
      label: 'Paket Bukti Forensik',
      desc: 'Lengkapi chain-of-custody & hash digital.'
    }, {
      to: '/platform-reporting',
      icon: ExternalLink,
      label: 'Lapor ke Platform',
      desc: 'Kirim takedown / restore request resmi.',
      badge: 'EKSTERNAL'
    }, {
      to: '/workbench',
      icon: Briefcase,
      label: 'Buka Workbench',
      desc: 'Analisis lintas-sumber untuk memperkuat berkas.'
    }, {
      to: '/reports',
      icon: FileText,
      label: 'Update Laporan Mingguan',
      desc: 'Sertakan kasus aktif di Crisis Alert Report.'
    }]} data-id="element-1394" />
    </div>;
}